import BConfig from "../../modules/BConfig";
import BApp from "../../modules/BApp";
import BRequest from "../../modules/BRequest";

export default class BSalesProductSetupDelegates
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.b-sales-product-setup-delegates`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("click", event => {
			if (event.target.matches(`${this.selector()}__create-button`)) {
				let form = new this(event.target.closest(this.selector()));
				let url = BConfig.getRoute("api.v2.userDelegateTokens.view")
					.replace("{token}", form.getInput().value)
					;

				BRequest.get(url).then(response => {
					form.addDelegate(response.data);
					form.getInput().value = "";
				}).catch(error => {
					console.log(error);
				});
			}
		});

		document.addEventListener("click", event => {
			if (event.target.matches(`${this.selector()}__delete-button`)) {
				let form = new this(event.target.closest(this.selector()));
				event.target.closest("tr").remove();
				form.refreshTableVisibility();
			}
		});
	}

	getInput()
	{
		return this.el.querySelector(`${BSalesProductSetupDelegates.selector()}__input`);
	}

	getTable()
	{
		return this.el.querySelector(`${BSalesProductSetupDelegates.selector()}__table`);
	}

	refreshTableVisibility()
	{
		this.getTable().hidden = !this.getTable().querySelectorAll("tbody tr").length;
	}

	getDelegateRow(delegate)
	{
		let row;

		this.getTable().querySelectorAll(`tbody [data-reference]`).forEach(el => {
			let reference = JSON.parse(el.dataset.reference);
			if (reference.delegateId == delegate.user.id && reference.scope == delegate.scope) {
				row = el;
			}
		});

		return row;
	}

	addDelegate(delegate)
	{
		if (this.getDelegateRow(delegate)) {
			return;
		};

		let el = BApp.createElement(delegate.templates.productSetupTableRow, "tbody");

		this.getTable().querySelector("tbody").append(el);
		this.refreshTableVisibility();
	}
}
